/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LanguageRead } from '../models/LanguageRead';
import type { LanguageWriteSerializerWithRepr } from '../models/LanguageWriteSerializerWithRepr';
import type { PaginatedLanguageListList } from '../models/PaginatedLanguageListList';
import type { PaginatedLanguageWriteSerializerWithReprList } from '../models/PaginatedLanguageWriteSerializerWithReprList';
import type { PatchedLanguageWriteSerializerWithRepr } from '../models/PatchedLanguageWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LanguagesService {
    /**
     * @returns PaginatedLanguageListList
     * @throws ApiError
     */
    public static languagesList({
        code,
        defaultPrompt,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        code?: Array<string>,
        defaultPrompt?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedLanguageListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/languages/',
            query: {
                'code': code,
                'default_prompt': defaultPrompt,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns LanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static languagesCreate({
        requestBody,
    }: {
        requestBody: LanguageWriteSerializerWithRepr,
    }): CancelablePromise<LanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/languages/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static languageBulkUpdate({
        requestBody,
        code,
        defaultPrompt,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<LanguageWriteSerializerWithRepr>,
        code?: Array<string>,
        defaultPrompt?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/languages/',
            query: {
                'code': code,
                'default_prompt': defaultPrompt,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static languageBulkPartialUpdate({
        requestBody,
        code,
        defaultPrompt,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<LanguageWriteSerializerWithRepr>,
        code?: Array<string>,
        defaultPrompt?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/languages/',
            query: {
                'code': code,
                'default_prompt': defaultPrompt,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static languageBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/languages/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns LanguageRead
     * @throws ApiError
     */
    public static languagesRetrieve({
        id,
        code,
        defaultPrompt,
        excludeFields,
        fields,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this language.
         */
        id: number,
        code?: Array<string>,
        defaultPrompt?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<LanguageRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/languages/{id}/',
            path: {
                'id': id,
            },
            query: {
                'code': code,
                'default_prompt': defaultPrompt,
                'exclude-fields': excludeFields,
                'fields': fields,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns LanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static languagesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this language.
         */
        id: number,
        requestBody: LanguageWriteSerializerWithRepr,
    }): CancelablePromise<LanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/languages/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns LanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static languagesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this language.
         */
        id: number,
        requestBody?: PatchedLanguageWriteSerializerWithRepr,
    }): CancelablePromise<LanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/languages/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static languagesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this language.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/languages/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
